import { bookingsAPI } from 'api/bookingsAPI'
import { useState } from 'react'

export default function useBooking() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [bookingData, setBookingData] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')

  const createBooking = async (data: object) => {
    setIsLoading(true)
    setError(false)

    try {
      const resp = await bookingsAPI.createBooking(data).catch((err) => {
        throw new Error(err)
      })
      setBookingData(resp.data ? resp.data : resp.error)
    } catch (error) {
      setError(true)
      const errorMessage = (error as Error)?.message || ''
      console.log('errorMessage', errorMessage)
      setErrorMessage(
        errorMessage.startsWith('Error: ')
          ? errorMessage.replace('Error: ', '')
          : errorMessage,
      )
    }

    setIsLoading(false)
  }

  const cancelBooking = async (bookingId: string) => {
    setIsLoading(true)
    setError(false)

    try {
      await bookingsAPI.cancelBookingReference(bookingId)
    } catch (error) {
      setError(true)
    }

    setIsLoading(false)
  }

  const cancelVehicle = async (jobReference: string) => {
    setIsLoading(true)
    setError(false)

    try {
      await bookingsAPI.cancelVehicle(jobReference)
    } catch (error) {
      setError(true)
    }

    setIsLoading(false)
  }

  return {
    bookingData,
    createBooking,
    cancelBooking,
    cancelVehicle,
    isLoading,
    error,
    errorMessage,
  }
}
